// import { GetAllOrdersByCustomerAction } from "../Slices/Customer/GetAllOrdersByCustomer";
import { GetAllChatRoomsWithReceiverInfoAction } from "../Slices/chat/GetAllChatRoomsWithReceiverInfo";
import { GetchatRoomMessageAction } from "../Slices/chat/GetchatRoomMessage";
import { sendMessageAction } from "../Slices/chat/sendMessage";
import { connectionRequestsFromUserAction } from "../Slices/Connections/connectionRequestsFromUser";
import { getAllUsersAction } from "../Slices/Connections/getAllUsers";
import { getUserConnectionsAction } from "../Slices/Connections/getUserConnections";
import { sendConnectionRequestAction } from "../Slices/Connections/sendConnectionRequest";
import { suggestConnectionsAction } from "../Slices/Connections/suggestConnections";
import { updateConnectionRequestStatusAction } from "../Slices/Connections/updateConnectionRequestStatus";
import { yourConnectionRequestsAction } from "../Slices/Connections/yourConnectionRequests";
import { createAwardAction } from "../Slices/EditProfile/createAward";
import { createEducationAction } from "../Slices/EditProfile/createEducation";
import { createExperienceAction } from "../Slices/EditProfile/createExperience";
import { createProjectAction } from "../Slices/EditProfile/createProject";
import { deleteAwardAction } from "../Slices/EditProfile/deleteAward";
import { deleteEducationAction } from "../Slices/EditProfile/deleteEducation";
import { deleteExperienceAction } from "../Slices/EditProfile/deleteExperience";
import { deleteProjectAction } from "../Slices/EditProfile/deleteProject";
import { getAwardByIdAction } from "../Slices/EditProfile/getAwardById";
import { getAwardsByUserIdAction } from "../Slices/EditProfile/getAwardsByUserId";
import { getEducationByIdAction } from "../Slices/EditProfile/getEducationById";
import { getExperienceByIdAction } from "../Slices/EditProfile/getExperienceById";
import { getExperiencesByUserIdAction } from "../Slices/EditProfile/getExperiencesByUserId";
import { getProjectByIdAction } from "../Slices/EditProfile/getProjectById";
import { getProjectsByUserIdAction } from "../Slices/EditProfile/getProjectsByUserId";
import { getUserAboutAction } from "../Slices/EditProfile/getUserAbout";
import { getUserProfileBannerAction } from "../Slices/EditProfile/getUserProfileBanner";
import { getUserSkillsAction } from "../Slices/EditProfile/getUserSkills";
import { ProfileviewDetailsByUserIdAction } from "../Slices/EditProfile/ProfileviewDetailsByUserId";
import { updateAwardAction } from "../Slices/EditProfile/updateAward";
import { updateEducationAction } from "../Slices/EditProfile/updateEducation";
import { updateExperienceAction } from "../Slices/EditProfile/updateExperience";
import { updateProjectAction } from "../Slices/EditProfile/updateProject";
import { updateUserStoreInfoAction } from "../Slices/EditProfile/updateUserStoreInfo";
import { usergetEducationsByUserIdAction } from "../Slices/EditProfile/usergetEducationsByUserId";
import { deleteEventAction } from "../Slices/Events/deleteEvent";
import { EventGetAllAction } from "../Slices/Events/EventGetAll";
import { EventGetByIdAction } from "../Slices/Events/EventGetById";
import { EventPostAction } from "../Slices/Events/EventPost";
import { updateEventAction } from "../Slices/Events/updateEvent";
import { editUserInfoAction } from "../Slices/Login/editUserInfo";
import { getAuthUserByIdAction } from "../Slices/Login/getAuthUserById";
import { loginAuthUserAction } from "../Slices/Login/loginAuthUser";
import { LoginPostAction } from "../Slices/Login/LoginPost";
import { resetPasswordForAuthUserAction } from "../Slices/Login/resetPasswordForAuthUser";
import { deleteMentorRequirementAction } from "../Slices/MentorRequirement/deleteMentorRequirement";
import { MentorRequirementGetAllAction } from "../Slices/MentorRequirement/MentorRequirementGetAll";
import { MentorRequirementGetByIdAction } from "../Slices/MentorRequirement/MentorRequirementGetById";
import { MentorRequirementPostAction } from "../Slices/MentorRequirement/MentorRequirementPost";
import { updateMentorRequirementAction } from "../Slices/MentorRequirement/updateMentorRequirement";
import { deleteNewsletterAction } from "../Slices/Newsletter/deleteNewsletter";
import { NewsLetterEditByIdAction } from "../Slices/Newsletter/NewsLetterEditById";
import { NewsletterGetAllAction } from "../Slices/Newsletter/NewsletterGetAll";
import { NewsletterGetByIdAction } from "../Slices/Newsletter/NewsletterGetById";
import { NewsletterPostAction } from "../Slices/Newsletter/NewsletterPost";
import { updateNewsletterAction } from "../Slices/Newsletter/updateNewsletter";
import { getNotificationCategoryCountsAction } from "../Slices/notification/getNotificationCategoryCounts";
import { getUnreadChatNotificationsAction } from "../Slices/notification/getUnreadChatNotifications";
import { getUnreadConnectionNotificationsAction } from "../Slices/notification/getUnreadConnectionNotifications";
import { getUnreadEventNotificationsAction } from "../Slices/notification/getUnreadEventNotifications";
import { getUnreadFeedNotificationsAction } from "../Slices/notification/getUnreadFeedNotifications";
import { getUnreadInternshipNotificationsAction } from "../Slices/notification/getUnreadInternshipNotifications";
import { getUnreadJobNotificationsAction } from "../Slices/notification/getUnreadJobNotifications";
import { getUnreadMentorRequirementNotificationsAction } from "../Slices/notification/getUnreadMentorRequirementNotifications";
import { getUnreadNewsletterNotificationsAction } from "../Slices/notification/getUnreadNewsletterNotifications";
import { getUserAllUnreadNotificationsAction } from "../Slices/notification/getUserAllUnreadNotifications";
import { markNotificationAsReadForUserAction } from "../Slices/notification/markNotificationAsReadForUser";
import { markRoomNotificationsAsReadAction } from "../Slices/notification/markRoomNotificationsAsRead";
import { commentOnFeedAction } from "../Slices/Post/commentOnFeed";
import { getCommentsWithRepliesAction } from "../Slices/Post/getCommentsWithReplies";
import { getFeedLikedUsersAction } from "../Slices/Post/getFeedLikedUsers";
import { getUserStatsCountAction } from "../Slices/Post/getUserStatsCount";
import { getUserStatsCountByUserIdAction } from "../Slices/Post/getUserStatsCountByUserId";
import { likeFeedAction } from "../Slices/Post/likeFeed";
import { replyToCommentAction } from "../Slices/Post/replyToComment";
import { unlikeFeedAction } from "../Slices/Post/unlikeFeed";
// import { unlikeFeedAction } from "../Slices/Post/unlikeFeed";
// import { likeFeedAction } from "../Slices/Posts/likeFeed";
import { AlumniRegistratioConfirmAction } from "../Slices/Reports/RegistrationConformation/AlumniRegistratioConfirm";
import { AlumniRegistrationGetAllAction } from "../Slices/Reports/RegistrationConformation/AlumniRegistrationGetAll";
import { AlumniRegistrationRejectAction } from "../Slices/Reports/RegistrationConformation/AlumniRegistrationReject";
import { addpostresumeAction } from "../Slices/Reports/RegistrationProfile/addpostresume";
import { AlumniAwardGetByIdAction } from "../Slices/Reports/RegistrationProfile/AlumniAwardGetById";
import { AlumniEducationGetByIdAction } from "../Slices/Reports/RegistrationProfile/AlumniEducationGetById";
import { AlumniExperienceGetByIdAction } from "../Slices/Reports/RegistrationProfile/AlumniExperienceGetById";
import { AlumniProjectGetByIdAction } from "../Slices/Reports/RegistrationProfile/AlumniProjectGetById";
import { AlumniSkillsGetByIdAction } from "../Slices/Reports/RegistrationProfile/AlumniSkillsGetById";
import { RegistrationProfileGetByIdAction } from "../Slices/Reports/RegistrationProfile/RegistrationProfileGetById";
import { globalSearchAction } from "../Slices/search/globalSearch";
import { getSiteSettingsAction } from "../Slices/UploadFiles/getSiteSettings";
import { saveSiteSettingsAction } from "../Slices/UploadFiles/saveSiteSettings";
import { uploadFilesPostAction } from "../Slices/UploadFiles/uploadFilesPost";
import { uploadImageAction } from "../Slices/UploadFiles/uploadImage";
import { uploadPdfAndImageAction } from "../Slices/UploadFiles/uploadPdfAndImage";
import { checkCustomerExistForEmailRegisterAction } from "../Slices/VerifyEmail/checkCustomerExistForEmailRegister";
import { checkCustomerExistPhoneForRegisterAction } from "../Slices/VerifyEmail/checkCustomerExistPhoneForRegister";
import { EmailSendOtpAction } from "../Slices/VerifyEmail/EmailSendOtp";
import { EmailVerifyOtpAction } from "../Slices/VerifyEmail/EmailVerifyOtp";
import { resetPasswordForUserAction } from "../Slices/VerifyEmail/resetPasswordForUser";
import { addpostinternshipAction } from "../Slices/Website/addpostinternship";
import { addpostjobAction } from "../Slices/Website/addpostjob";
import { aluminipostlikeAction } from "../Slices/Website/aluminipostlike";
import { aluminipostlikeGetAction } from "../Slices/Website/aluminipostlikeGet";
import { AlumniProfileGetByIdAction } from "../Slices/Website/AlumnipProfileGetById";
import { ConnectionRequestPostAction } from "../Slices/Website/ConnectionRequestPost";
import { ConnectionsGetAllAction } from "../Slices/Website/ConnectionsGetAll";
import { createFeedAction } from "../Slices/Website/createFeed";
import { deleteInternshipByIdAction } from "../Slices/Website/deleteInternshipById";
import { deleteJobByIdAction } from "../Slices/Website/deleteJobById";
import { getInternshipByIdAction } from "../Slices/Website/getInternshipById";
import { getInternshipsByUserIdAction } from "../Slices/Website/getInternshipsByUserId";
import { getJobByIdAction } from "../Slices/Website/getJobById";
import { getUserAndConnectionsFeedsWithLikeWithCommentAction } from "../Slices/Website/getUserAndConnectionsFeedsWithLikeWithComment";
import { getUserByIdAction } from "../Slices/Website/getUserById";
import { JobPostGetAllAction } from "../Slices/Website/JobPostGetAll";
import { MyPostForusersAction } from "../Slices/Website/MyPostForusers";
import { MyPostForUsersGetAllAction } from "../Slices/Website/MyPostForUsersGetAll";
import { RegisterPostAction } from "../Slices/Website/RegisterPost";
// import { websitehomepageGetyTokenAction } from "../Slices/Website/websitehomepageGetByToken";





const actions = {

  ...LoginPostAction,
  ...EventPostAction,
  ...EventGetAllAction,
  ...MentorRequirementGetAllAction,
  ...MentorRequirementPostAction,
  ...NewsletterGetAllAction,
  ...NewsletterPostAction,
  ...NewsletterGetByIdAction,
  ...NewsLetterEditByIdAction,
  ...EventGetByIdAction,
  ...MentorRequirementGetByIdAction,
  ...AlumniRegistrationGetAllAction,
  ...AlumniRegistratioConfirmAction,
  ...AlumniRegistrationRejectAction,
  ...RegistrationProfileGetByIdAction,
  ...AlumniSkillsGetByIdAction,
  ...AlumniAwardGetByIdAction,
  ...AlumniProjectGetByIdAction,
  ...AlumniExperienceGetByIdAction,
  ...AlumniEducationGetByIdAction,
  ...RegisterPostAction,
  ...AlumniProfileGetByIdAction,
  // ...websitehomepageGetByTokenAction,
  ...addpostjobAction,
  ...JobPostGetAllAction,
  ...addpostinternshipAction,
  ...addpostresumeAction,
  ...MyPostForusersAction,
  ...MyPostForUsersGetAllAction,
  ...ConnectionsGetAllAction,
  ...ConnectionRequestPostAction,
  ...aluminipostlikeAction,
  ...aluminipostlikeGetAction,
  ...getInternshipByIdAction,
  ...getInternshipsByUserIdAction,
  ...deleteInternshipByIdAction,

  ...saveSiteSettingsAction,
  ...getSiteSettingsAction,
  // ------------------------------------
  ...createFeedAction,
  ...uploadFilesPostAction,
  ...getUserAndConnectionsFeedsWithLikeWithCommentAction,
  ...likeFeedAction,
  ...unlikeFeedAction,
  ...getCommentsWithRepliesAction,
  ...commentOnFeedAction,
  ...replyToCommentAction,
  ...getUserByIdAction,
  ...connectionRequestsFromUserAction,
  ...yourConnectionRequestsAction,
  ...updateConnectionRequestStatusAction,
  ...getAllUsersAction,
  ...sendConnectionRequestAction,
  ...EmailVerifyOtpAction,
  ...EmailSendOtpAction,
  ...checkCustomerExistForEmailRegisterAction,
  ...checkCustomerExistPhoneForRegisterAction,

  ...suggestConnectionsAction,
  ...deleteJobByIdAction,
  ...getJobByIdAction,
  ...getUserConnectionsAction,
  ...getUserStatsCountAction,
  ...createAwardAction,
  ...uploadPdfAndImageAction,
  ...getAwardsByUserIdAction,
  ...getAwardByIdAction,
  ...updateAwardAction,
  ...deleteAwardAction,

  ...createEducationAction,
  ...getEducationByIdAction,
  ...usergetEducationsByUserIdAction,
  ...updateEducationAction,
  ...deleteEducationAction,
  ...createExperienceAction,
  ...getExperienceByIdAction,
  ...getExperiencesByUserIdAction,
  ...updateExperienceAction,
  ...deleteExperienceAction,
  ...createProjectAction,
  ...getProjectsByUserIdAction,
  ...getProjectByIdAction,
  ...updateProjectAction,
  ...deleteProjectAction,
  ...getUserSkillsAction,
  ...updateUserStoreInfoAction,
  ...loginAuthUserAction,
  ...updateEventAction,
  ...deleteEventAction,
  ...deleteMentorRequirementAction,
  ...updateMentorRequirementAction,
  ...deleteNewsletterAction,
  ...updateNewsletterAction,
  ...getAuthUserByIdAction,
  ...getUserAboutAction,
  ...getFeedLikedUsersAction,
  ...resetPasswordForUserAction,
  ...resetPasswordForAuthUserAction,
  // -----------
  ...globalSearchAction,
  ...uploadImageAction,


  // 
  //

  ...getNotificationCategoryCountsAction,
  ...markRoomNotificationsAsReadAction,
  ...getUserAllUnreadNotificationsAction,
  ...getUnreadFeedNotificationsAction,
  ...getUnreadConnectionNotificationsAction,
  ...getUnreadChatNotificationsAction,
  ...getUnreadInternshipNotificationsAction,
  ...getUnreadJobNotificationsAction,
  ...getUnreadEventNotificationsAction,
  ...getUnreadMentorRequirementNotificationsAction,
  ...getUnreadNewsletterNotificationsAction,
  ...markNotificationAsReadForUserAction,
  ...ProfileviewDetailsByUserIdAction,
  ...getUserStatsCountByUserIdAction,
  ...editUserInfoAction,
  ...getUserProfileBannerAction,







  // 
  ...GetAllChatRoomsWithReceiverInfoAction,
  ...GetchatRoomMessageAction,
  ...sendMessageAction
};

export default actions;
